import api from "../axios";

export const DOCUMENT_BILLING_AUTHORIZATION_ID = 1;
export const DOCUMENT_LETTER_OF_CREDIT_ID = 2;
export const DOCUMENT_ACKNOWLEDGEMENT_ID = 3;

export interface SignatureSummary {
  id: number;
  uuid: string;
  createdAt: string;
  documentId: number;
  documentName: string;
  /** Name the user typed at sign time. Null for legacy pre-migration rows. */
  name: string | null;
}

export function getMySignatures() {
  return api.get<SignatureSummary[]>("/signatures");
}

export interface SignatureMetadata {
  inviteUuid?: string;
  policyUuid?: string;
  policyTermUuid?: string;
}

export function signDocument(
  documentId: number,
  name: string,
  metadata?: SignatureMetadata,
) {
  return api.post<SignatureSummary>("/signatures", {
    documentId,
    name,
    metadata,
  });
}

export function downloadSignedDocument(documentId: number) {
  return api.get<Blob>(`/signatures/${documentId}/download`, {
    responseType: "blob",
  });
}
